export default __webpack_public_path__ + "img/5f651062c6143c216f5a0089dfbf1fee.svg";